/* eslint-disable no-param-reassign,no-cond-assign,no-undef */
import _ from 'lodash';

export function isTouch() {
  return (typeof window !== 'undefined' && 'ontouchstart' in window);
}

export function hasClass(el, c) {
  if (!el || !el.className) return false;
  return _.some(el.className.split(' '), e => e === c);
}

export function addClass(el, c) {
  const add = (e) => {
    if (!e || hasClass(e, c)) return;
    const arr = e.className ? e.className.split(' ') : [];
    arr.push(c);
    e.className = arr.join(' ');
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), add);
  } else {
    add(el);
  }
}

export function removeClass(el, c) {
  const remove = (e) => {
    if (!e) return;
    const arr = e.className.split(' ');
    _.remove(arr, v => v === c);
    e.className = arr.join(' ');
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), remove);
  } else {
    remove(el);
  }
}

export function toggleClass(el, c) {
  const toggle = (e) => {
    if (hasClass(e, c)) removeClass(e, c);
    else addClass(e, c);
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), toggle);
  } else {
    toggle(el);
  }
}

let scrollBody;
export function getScrollBody() {
  if (scrollBody) return scrollBody;
  if (document.documentElement.scrollTop > 0) {
    scrollBody = window.$(document.documentElement);
  } else if (document.body.scrollTop > 0) {
    scrollBody = window.$(document.body);
  }
  return scrollBody || window.$('body,html');
}

export function getOffsetTop(el) {
  let t1;
  let t0;
  if (!el) return -1;
  t0 = el;
  t1 = el.offsetTop;
  while (t0 !== t0.offsetParent && (t0 = t0.offsetParent) !== null && t0.nodeName !== 'body' && t0) { t1 += t0.offsetTop; }
  return t1;
}



// WEBPACK FOOTER //
// ./src/utils/index.js